import { extractTokensFromResponse } from '../helpers/extractTokensFromResponse';
import { storeTokens } from '../helpers/storeTokens';
import { OpenIdError } from '../lib/oauth4webapi/OpenIdError';
import { useExchangeRefreshTokenMutation } from '../queries/useExchangeRefreshTokenMutation';
import { isTokenPossiblyValid } from '../tokens/tokenWithExpiration';
// I guessed this
const MAX_FAILED_REFRESH_REQUESTS = 5;
export const useRefreshTokensHandler = ({ tokenStorage, clientCredentials, authorizationServer, onSettled, }) => {
    const exchangeRefreshTokenMutation = useExchangeRefreshTokenMutation();
    const handleRefreshTokens = () => {
        const refreshToken = tokenStorage.refreshToken.get();
        if (!authorizationServer ||
            !refreshToken ||
            !isTokenPossiblyValid(refreshToken) ||
            exchangeRefreshTokenMutation.isPending)
            return;
        exchangeRefreshTokenMutation.mutate({
            authorizationServer,
            clientCredentials,
            refreshToken: refreshToken.token,
        }, {
            onSuccess: (tokenResponse) => {
                const tokens = extractTokensFromResponse(tokenResponse);
                storeTokens(tokenStorage, tokens);
            },
            onError: (error) => {
                const isAuthenticationError = error instanceof OpenIdError;
                const failureCount = exchangeRefreshTokenMutation.failureCount + 1;
                if (isAuthenticationError ||
                    failureCount >= MAX_FAILED_REFRESH_REQUESTS) {
                    tokenStorage.refreshToken.remove();
                }
            },
            onSettled,
        });
    };
    return {
        handleRefreshTokens,
        isRefreshingTokens: exchangeRefreshTokenMutation.isPending,
    };
};
